function IntroSection() {
	this.build();
}

IntroSection.prototype.build = function () {

	this.item = $('.intro-link');
	this.item.on('click', function () {
		if (scrollBar) {
			scrollBar.scrollIntoView($('.section-intro').next()[0]);
		} else {
			$('.section-intro').next()[0].scrollIntoView({behavior: "smooth"});
		}
	});

	const titleContainer = document.querySelector('.title-container');
	const introPhoto = document.querySelector('.intro-photo');

	if (!mobileCheck.isMobile && titleContainer) {
		gsap.to(titleContainer, {
			opacity: 0,
			ease: 'none',
			scrollTrigger: {
				trigger: '.section-intro',
				start: 'top top',
				end: 'bottom center',
				scrub: true
			}
		});
	}

	if (!mobileCheck.isMobile && introPhoto) {
		gsap.to(introPhoto, {
			y: '50%',
			ease: 'none',
			scrollTrigger: {
				trigger: '.section-intro',
				start: 'top top',
				end: 'bottom top',
				scrub: true
			}
		});
	}
};
